<template>
  <a-modal
      v-model:visible="visible"
      :title="isEditMode ? '修改项目服务单' : '新增项目服务单'"
      :on-before-ok="handleOk"
      @cancel="handleCancel"
      width="1200px"
      :mask-closable="false"
      :ok-loading="loading"
      draggable
  >
    <a-form ref="formRef" :model="formData" :rules="rules" layout="vertical">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="项目任务单ID" field="projectTaskId">
            <a-input-number 
              v-model="formData.projectTaskId" 
              placeholder="请输入项目任务单ID" 
              :min="1"
              :precision="0"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="所属客户编码" field="customerCode">
            <a-input v-model="formData.customerCode" placeholder="请输入客户编码" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="所属门店编码" field="storeCode">
            <a-input v-model="formData.storeCode" placeholder="请输入门店编码" allow-clear />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="服务类型" field="serviceType">
            <a-select v-model="formData.serviceType" placeholder="请选择服务类型" allow-clear>
              <!-- TODO 待替换数据字典 -->
              <a-option value="1">杀虫</a-option>
              <a-option value="2">消毒</a-option>
              <a-option value="3">专项</a-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="任务单类型" field="taskCategory">
            <a-select v-model="formData.taskCategory" placeholder="请选择任务单类型" allow-clear>
              <!-- TODO 待替换数据字典 -->
              <a-option value="1">常规</a-option>
              <a-option value="2">应急</a-option>
              <a-option value="3">检查</a-option>
              <a-option value="4">首次</a-option>
              <a-option value="5">临时</a-option>
              <a-option value="6">勘察</a-option>
              <a-option value="7">专项</a-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="服务频次" field="serviceFrequency">
            <a-input v-model="formData.serviceFrequency" placeholder="请输入服务频次" allow-clear />
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="服务内容" field="serviceContent">
        <a-textarea 
          v-model="formData.serviceContent" 
          placeholder="请输入服务内容"
          :rows="3"
          allow-clear 
        />
      </a-form-item>

      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="总需服务次数" field="totalServiceCount">
            <a-input-number 
              v-model="formData.totalServiceCount" 
              placeholder="请输入总需服务次数" 
              :min="1"
              :precision="0"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="已完成服务次数" field="completedServiceCount">
            <a-input-number 
              v-model="formData.completedServiceCount" 
              placeholder="请输入已完成服务次数" 
              :min="0"
              :precision="0"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="服务人员编码" field="serviceStaffCode">
            <a-input v-model="formData.serviceStaffCode" placeholder="请输入服务人员编码" allow-clear />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item label="服务开始时间" field="serviceStartTime">
            <a-date-picker 
              v-model="formData.serviceStartTime"
              style="width: 100%" 
              show-time
              placeholder="请选择服务开始时间"
              format="YYYY-MM-DD HH:mm"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="服务结束时间" field="serviceEndTime">
            <a-date-picker 
              v-model="formData.serviceEndTime"
              style="width: 100%" 
              show-time
              placeholder="请选择服务结束时间"
              format="YYYY-MM-DD HH:mm"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="单次金额(元)" field="unitPrice">
            <a-input-number 
              v-model="formData.unitPrice" 
              placeholder="请输入单次金额" 
              :min="0"
              :precision="2"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="单次服务人时" field="unitServiceHours">
            <a-input-number 
              v-model="formData.unitServiceHours" 
              placeholder="请输入单次服务人时" 
              :min="0"
              :precision="2"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="是否强制协同" field="isOvertime">
            <a-select v-model="formData.isOvertime" placeholder="请选择是否强制协同" allow-clear>
              <a-option :value="0">否</a-option>
              <a-option :value="1">是</a-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item label="服务状态" field="serviceStatus">
            <!-- TODO 待替换数据字典 -->
            <a-select v-model="formData.serviceStatus" placeholder="请选择服务状态" allow-clear>
              <a-option :value="1">待服务</a-option>
              <a-option :value="2">服务中</a-option>
              <a-option :value="3">已完成</a-option>
              <a-option :value="4">已取消</a-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="备注" field="remark">
            <a-input v-model="formData.remark" placeholder="请输入备注" allow-clear />
          </a-form-item>
        </a-col>
      </a-row>

<!--      <a-form-item label="扩展字段(JSON格式)" field="extensionFields">-->
<!--        <a-textarea -->
<!--          v-model="formData.extensionFields" -->
<!--          placeholder="请输入JSON格式的扩展字段，例如：{&quot;key1&quot;: &quot;value1&quot;, &quot;key2&quot;: &quot;value2&quot;}"-->
<!--          :rows="4"-->
<!--          allow-clear -->
<!--        />-->
<!--      </a-form-item>-->

      <!-- 项目服务单异常记录 -->
      <a-divider>项目服务单异常记录</a-divider>
      <div v-if="formData.projectServiceExceptionList && formData.projectServiceExceptionList.length > 0">
        <div v-for="(exception, index) in formData.projectServiceExceptionList" :key="index" class="exception-item">
          <a-row :gutter="16">
            <a-col :span="8">
              <a-form-item :label="`异常状态 ${index + 1}`">
                <a-select v-model="exception.exceptionStatus" placeholder="请选择异常状态">
                  <!-- TODO 待替换数据字典 -->
                  <a-option :value="1">暂停</a-option>
                  <a-option :value="2">终止</a-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="`异常开始时间 ${index + 1}`">
                <a-date-picker 
                  v-model="exception.exceptionStartTime"
                  style="width: 100%" 
                  show-time
                  placeholder="请选择异常开始时间"
                  format="YYYY-MM-DD HH:mm"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="`异常恢复时间 ${index + 1}`">
                <a-date-picker 
                  v-model="exception.exceptionRecoveryTime"
                  style="width: 100%" 
                  show-time
                  placeholder="请选择异常恢复时间"
                  format="YYYY-MM-DD HH:mm"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item :label="`异常原因 ${index + 1}`">
                <a-textarea 
                  v-model="exception.exceptionReason" 
                  placeholder="请输入异常原因"
                  :rows="2"
                />
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item :label="`解决方案 ${index + 1}`">
                <a-textarea 
                  v-model="exception.solution" 
                  placeholder="请输入解决方案"
                  :rows="2"
                />
              </a-form-item>
            </a-col>
            <a-col :span="2" style="display: flex; align-items: end;">
              <a-button type="outline" status="danger" @click="removeException(index)" style="margin-bottom: 8px;">
                删除
              </a-button>
            </a-col>
          </a-row>
        </div>
      </div>
      <a-button type="dashed" @click="addException" style="width: 100%; margin-top: 10px;">
        + 添加异常记录
      </a-button>
    </a-form>
  </a-modal>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue'
import { Message } from '@arco-design/web-vue'
import { 
  addProjectServiceOrder, 
  updateProjectServiceOrder,
  getProjectServiceOrderInfo, 
} from '@/apis/work-order-api'
import {dateTimeString2timestampNumber} from "@/utils/date-util";

// 定义 props
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  serviceOrderId: {
    type: [String, Number],
    default: null
  }
})

// 定义 emits
const emit = defineEmits(['update:modelValue', 'success'])

// 响应式数据
const visible = ref(false)
const loading = ref(false)
const formRef = ref()

// 判断是否为编辑模式
const isEditMode = ref(false)

// 表单数据
const formData = ref({
  id: null,
  projectTaskId: null,
  customerCode: '',
  storeCode: '',
  serviceType: '',
  taskCategory: '',
  serviceContent: '',
  serviceFrequency: '',
  totalServiceCount: null,
  serviceStartTime: '',
  serviceEndTime: '',
  serviceStaffCode: '',
  unitPrice: null,
  unitServiceHours: null,
  isOvertime: 0,
  serviceStatus: 1,
  completedServiceCount: 0,
  // extensionFields: '',
  remark: '',
  projectServiceExceptionList: []
})

// 表单验证规则
const rules = ref({
  projectTaskId: [
    { required: true, message: '请输入项目任务单ID' }
  ],
  customerCode: [
    { required: true, message: '请输入客户编码' },
    { min: 1, max: 50, message: '客户编码长度为1-50个字符' }
  ],
  storeCode: [
    { required: true, message: '请输入门店编码' },
    { min: 1, max: 50, message: '门店编码长度为1-50个字符' }
  ],
  serviceType: [
    { required: true, message: '请选择服务类型' }
  ],
  serviceContent: [
    { required: true, message: '请输入服务内容' },
    { max: 500, message: '服务内容长度不能超过500个字符' }
  ],
  totalServiceCount: [
    { required: true, message: '请输入总需服务次数' }
  ],
  serviceStartTime: [
    { required: true, message: '请选择服务开始时间' }
  ],
  serviceEndTime: [
    { required: true, message: '请选择服务结束时间' }
  ],
  serviceStatus: [
    { required: true, message: '请选择服务状态' }
  ]
})

// 监听 modelValue 变化
watch(() => props.modelValue, (newVal) => {
  visible.value = newVal
  if (newVal) {
    if (props.serviceOrderId) {
      isEditMode.value = true
      fetchServiceOrderInfo()
    } else {
      isEditMode.value = false
      resetForm()
    }
  }
})

// 监听 visible 变化
watch(visible, (newVal) => {
  emit('update:modelValue', newVal)
})

// 重置表单
const resetForm = () => {
  formData.value = {
    id: null,
    projectTaskId: null,
    customerCode: '',
    storeCode: '',
    serviceType: '',
    taskCategory: '',
    serviceContent: '',
    serviceFrequency: '',
    totalServiceCount: null,
    serviceStartTime: '',
    serviceEndTime: '',
    serviceStaffCode: '',
    unitPrice: null,
    unitServiceHours: null,
    isOvertime: 0,
    serviceStatus: 1,
    completedServiceCount: 0,
    // extensionFields: '',
    remark: '',
    projectServiceExceptionList: []
  }
  
  nextTick(() => {
    formRef.value?.clearValidate()
  })
}

// 获取项目服务单信息
const fetchServiceOrderInfo = async () => {
  if (!props.serviceOrderId) return
  
  loading.value = true
  try {
    const response = await getProjectServiceOrderInfo(props.serviceOrderId)
    if (response.code === 0) {
      const data = response.data
      formData.value = {
        id: data.id,
        projectTaskId: data.projectTaskId || null,
        customerCode: data.customerCode || '',
        storeCode: data.storeCode || '',
        serviceType: data.serviceType || '',
        taskCategory: data.taskCategory || '',
        serviceContent: data.serviceContent || '',
        serviceFrequency: data.serviceFrequency || '',
        totalServiceCount: data.totalServiceCount || null,
        serviceStartTime: data.serviceStartTime || '',
        serviceEndTime: data.serviceEndTime || '',
        serviceStaffCode: data.serviceStaffCode || '',
        unitPrice: data.unitPrice || null,
        unitServiceHours: data.unitServiceHours || null,
        isOvertime: data.isOvertime || 0,
        serviceStatus: data.serviceStatus || 1,
        completedServiceCount: data.completedServiceCount || 0,
        // extensionFields: typeof data.extensionFields === 'object' 
        //   ? JSON.stringify(data.extensionFields, null, 2) 
        //   : data.extensionFields || '',
        remark: data.remark || '',
        projectServiceExceptionList: data.projectServiceExceptionList || []
      }
    } else {
      Message.error(response.message || '获取项目服务单信息失败')
    }
  } catch (error) {
    Message.error('获取项目服务单信息失败')
    console.error('获取项目服务单信息失败:', error)
  } finally {
    loading.value = false
  }
}

// 添加异常记录
const addException = () => {
  formData.value.projectServiceExceptionList.push({
    exceptionStatus: 1,
    exceptionStartTime: '',
    exceptionRecoveryTime: '',
    exceptionReason: '',
    solution: '',
    // extensionFields: '',
    remark: ''
  })
}

// 删除异常记录
const removeException = (index) => {
  formData.value.projectServiceExceptionList.splice(index, 1)
}

// 处理确认按钮
const handleOk = async (done) => {
  try {
    // 验证表单
    const validateResult = await formRef.value?.validate()
    
    // 如果验证失败，阻止提交和关闭弹框
    if (validateResult !== undefined) {
      done(false)
      return false
    }
    
    loading.value = true
    
    // 准备提交数据
    const submitData = { ...formData.value }

    // 处理时间
    submitData.serviceStartTime = dateTimeString2timestampNumber(submitData.serviceStartTime)
    submitData.serviceEndTime = dateTimeString2timestampNumber(submitData.serviceEndTime)
    submitData.projectServiceExceptionList.forEach(item => {
      item.exceptionStartTime = dateTimeString2timestampNumber(item.exceptionStartTime)
      item.exceptionRecoveryTime = dateTimeString2timestampNumber(item.exceptionRecoveryTime)
    })
    
    // 处理扩展字段
    // if (submitData.extensionFields) {
    //   try {
    //     submitData.extensionFields = JSON.parse(submitData.extensionFields)
    //   } catch (e) {
    //     Message.error('扩展字段格式不正确，请输入有效的JSON格式')
    //     loading.value = false
    //     done(false)
    //     return false
    //   }
    // }
    
    let response
      if (isEditMode.value) {
        response = await updateProjectServiceOrder(submitData)
      } else {
        delete submitData.id // 新增时删除id字段
        response = await addProjectServiceOrder(submitData)
      }
    
    if (response.code === 0) {
      Message.success(isEditMode.value ? '修改项目服务单成功' : '新增项目服务单成功')
      emit('success')
      visible.value = false
      done(true)
      return true
    } else {
      Message.error(response.message || `${isEditMode.value ? '修改' : '新增'}项目服务单失败`)
      done(false)
    }
  } catch (error) {
    // 如果是表单验证错误，不显示网络错误提示
    if (error && typeof error === 'object' && error.name !== 'ValidateError') {
      Message.error(`${isEditMode.value ? '修改' : '新增'}项目服务单失败`)
      console.error('操作失败:', error)
    }
    done(false)
    return false
  } finally {
    loading.value = false
  }
}

// 处理取消按钮
const handleCancel = () => {
  formRef.value?.clearValidate()
  visible.value = false
}
</script>

<style scoped>
.a-form-item {
  margin-bottom: 16px;
}

.exception-item {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: #f9fafb;
}
</style>